export default "__VITE_ASSET__DV9zS$Kr__"